import { Component, Input } from '@angular/core';
import { SortOption } from '../../models/shared/sort-option.model';
import { SortOrder } from '../../models/shared/sort-order.model';

@Component({
  selector: 'ct-sort-indicator',
  templateUrl: './sort-indicator.component.html',
  styleUrls: ['./sort-indicator.component.css']
})
export class SortIndicatorComponent {
  @Input()
  sortKey = '';
  @Input()
  sortOption: SortOption;

  isKeyAscOrder() {
    return (
      this.sortOption.sortKey === this.sortKey &&
      this.sortOption.sortOrder === SortOrder.Asc
    );
  }

  isKeyDescOrder() {
    return (
      this.sortOption.sortKey === this.sortKey &&
      this.sortOption.sortOrder === SortOrder.Desc
    );
  }
}
